import "./ProfileBasicDetailsCardComponent.scss";

interface ProfileBasicDetailsCardComponentProps {
    currentUser: any;
}

const ProfileBasicDetailsCardComponent = (props: ProfileBasicDetailsCardComponentProps) => {
    const {currentUser} = props;

    return (
        <div className={'profile-basic-details-card-component'}>
            <div className={'profile-basic-detail-card'}>
                {/*<div className={'profile-basic-detail-card-upper-portion'}>*/}
                    {/*<div className={'profile-image-wrapper'}>*/}
                    {/*    <AvatarComponent title={currentUser?.first_name + " " + currentUser?.last_name}/>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className={'card-heading'}>
                    Account Settings
                </div>
                <div className={'profile-details-wrapper'}>
                    <div className={'profile-name'}>
                        {currentUser?.first_name} {currentUser?.last_name}
                    </div>
                    {/*<div className={'profile-status-wrapper'}>*/}
                    {/*    <ChipComponent color={'success'} label={currentUser?.is_active ? 'Active' : 'Inactive'}*/}
                    {/*                   className={`profile-status ${currentUser?.is_active ? "active" : "inactive"}`}/>*/}
                    {/*</div>*/}
                    <div className={'dashed-border-wrapper'}>
                        <div className={'dashed-border'}/>
                    </div>
                    {/*<div className={'profile-id-age-wrapper'}>*/}
                    {/*    <DataLabelValueComponent label={'Client ID'}>*/}
                    {/*        {currentUser?.client_id || 'N/A'}*/}
                    {/*    </DataLabelValueComponent>*/}
                    {/*    <DataLabelValueComponent label={'Age'} className={'age-container'}>*/}
                    {/*        {currentUser?.dob ? CommonService.getTheDifferenceBetweenDates(currentUser?.dob) : 'N/A'}*/}
                    {/*    </DataLabelValueComponent>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );

};

export default ProfileBasicDetailsCardComponent;
